import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-24/task-01";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "Consider the room below. Dots represent the original source (orange dot) and image sources<br>due to one reflection (dark blue dots) and image sources due to two reflections (light gray dots).",
  description: "Select which image sources should be placed in spots A, B and C.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/24/task/task-1.svg`,
                },
              },
              styles: {
                padding: "3%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
